import React from "react";

export default function Component({ subtitle = "Loading...", progress = 0 }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        width: "100%"
      }}
    >
      <div
        className="w-full h-2 bg-gray-200 rounded-full relative overflow-hidden border border-solid border-primary-200"
        style={{
          width: "100%",
          height: "12px",
        }}
      >
        <div
          className="transition-all duration-300 ease-in-out animate-gradient"
          style={{
            width: `${progress}%`,
            height: "100%",
            borderRadius: "4px",
            background: "linear-gradient(270deg, #1ab396, #14997e, #1ab396)",
            boxShadow: "inset 0 1px 2px rgba(0,0,0,0.1), 0 0 3px rgba(20, 153, 126, 0.5)",
            backgroundSize: "200% 100%",
          }}
        />
        <style>{`
          @keyframes gradient {
            0% {
              background-position: 0% 50%;
            }
            100% {
              background-position: -200% 50%;
            }
          }
          .animate-gradient {
          animation: gradient 8s linear infinite;
          }
        `}</style>
      </div>
      <div className="text-xs text-gray-500 mt-2">
        {subtitle}
      </div>
    </div>
  );
}
